/**
 * Data Manipulation Utilities
 */

/**
 * Filters an array of objects by a case insensitive predicate
 * @param {Array} data An array of objects to be filtered for a specified predicate
 * @param {String} filterStr The string predicate to filter the array for
 * @returns An array of objects containing strings that match the predicate. Case insensitive.
 */
const filterData = (data, filterStr) => {
  try {
    // if no filter predicate is passed, return data as is.
    if (!filterStr || filterStr.trim() === '') {
      return data;
    }

    const objectsWithValue = [];

    data.forEach((i) => {
      let values = Object.values(i).toString().toLowerCase();
      if (values.includes(filterStr.toLowerCase()) && !objectsWithValue.includes(i)) {
        objectsWithValue.push(i);
        return;
      }
      if (i.payload) {
        i.payload.forEach((load) => {
          values = Object.values(load).toString().toLowerCase();
          if (values.includes(filterStr.toLowerCase()) && !objectsWithValue.includes(i)) {
            objectsWithValue.push(i);
          }
        });
      }
    });
    return objectsWithValue;
  } catch (e) {
    console.log(e);
  }
};

/**
 * Paginates an array of objects by given page number and returns specified number of elements
 * @param {Array} data An array of objects to be paginated
 * @param {Number} page The page to be returned by function
 * @param {Number} rowsPerPage The number of elements to be returned in the page
 * @returns An array containing specified number of elements of paginated data
 */
const paginateData = (data, page, rowsPerPage) => {
  let paginated = [];
  if (page === 1) {
    paginated = data.slice(0, rowsPerPage);
  } else {
    paginated = data.slice((page - 1) * rowsPerPage, rowsPerPage * page);
  }

  return paginated;
};

export default {
  filterData,
  paginateData,
};
